 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"special-discounts":"special-discounts","cruise-edit":"cruise-edit","cruises":"cruises","discounts":"discounts","ships":"ships","customer-create":"customer-create","customer-edit":"customer-edit","manager-create":"manager-create","manager-edit":"manager-edit","offer-create":"offer-create","offer-edit":"offer-edit","user-create":"user-create","user-edit":"user-edit","dashboard":"dashboard","orders":"orders","customers":"customers","managers":"managers","offers":"offers","users":"users"}[chunkId]||chunkId) + "." + {"chunk-3116ee50":"0b7373d0","chunk-2cd2af4c":"feb6d762","chunk-519266b8":"cc55e759","chunk-531460d6":"5c80149f","chunk-71c199a0":"82be41f9","chunk-2d238485":"b938e781","special-discounts":"ecd8ca28","chunk-dddfc850":"335f4562","chunk-24f583fd":"2a290fb0","chunk-2d21df6c":"22f603a6","chunk-442933af":"2af8c3df","cruise-edit":"13fe950e","cruises":"a8e35a85","discounts":"4e34eca3","ships":"d8385e05","chunk-79b30151":"22a407c9","chunk-2d2088b5":"49dac4d1","chunk-72a69a57":"cfdc2c68","chunk-2d0c7cc6":"04eb5994","chunk-53ea0f5a":"5cddfd60","chunk-8c845234":"11e71c0b","chunk-042822bf":"381728a6","chunk-37415666":"994c408b","chunk-5d45888e":"0fea0901","chunk-745d6175":"0eaaebba","chunk-9a03d3ae":"15f6662a","chunk-b02a382c":"a1208c3f","chunk-375e64b9":"ce7598ae","chunk-5cd4f878":"5156c814","chunk-726df261":"5103db99","chunk-2d0df469":"444e0f00","chunk-9ddedc26":"8e60883f","chunk-c329f076":"06ac17f0","customer-create":"ad217154","customer-edit":"2b16e1ec","manager-create":"05ec5312","manager-edit":"aed22639","offer-create":"1251bbe8","offer-edit":"b9a28ba5","user-create":"d37ac869","user-edit":"494a30b0","chunk-00d40b96":"16fb6053","chunk-16eba1b2":"88f46dfa","dashboard":"78fd4446","orders":"7ac3de0f","chunk-487b9338":"1dcd9689","chunk-51f2f11e":"b3195c98","chunk-6580c0fe":"b02c3e6f","chunk-7feb6954":"aea39927","chunk-816b0afa":"29ce42d4","chunk-a0da63a2":"c0545a14","chunk-ac25a1f4":"8b478b67","customers":"9b12635e","managers":"28dd7074","offers":"64d35f9d","users":"02737472","chunk-8c9caf88":"991cc0f4"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-2cd2af4c":1,"chunk-519266b8":1,"chunk-531460d6":1,"chunk-71c199a0":1,"special-discounts":1,"chunk-dddfc850":1,"chunk-24f583fd":1,"cruise-edit":1,"cruises":1,"discounts":1,"ships":1,"chunk-79b30151":1,"chunk-72a69a57":1,"chunk-8c845234":1,"chunk-042822bf":1,"chunk-37415666":1,"chunk-5d45888e":1,"chunk-745d6175":1,"chunk-9a03d3ae":1,"chunk-b02a382c":1,"chunk-375e64b9":1,"chunk-5cd4f878":1,"chunk-726df261":1,"chunk-c329f076":1,"customer-create":1,"customer-edit":1,"manager-create":1,"manager-edit":1,"offer-create":1,"offer-edit":1,"user-create":1,"user-edit":1,"chunk-00d40b96":1,"chunk-16eba1b2":1,"dashboard":1,"orders":1,"chunk-487b9338":1,"chunk-51f2f11e":1,"chunk-6580c0fe":1,"chunk-7feb6954":1,"chunk-816b0afa":1,"chunk-a0da63a2":1,"chunk-ac25a1f4":1,"customers":1,"managers":1,"offers":1,"users":1,"chunk-8c9caf88":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"special-discounts":"special-discounts","cruise-edit":"cruise-edit","cruises":"cruises","discounts":"discounts","ships":"ships","customer-create":"customer-create","customer-edit":"customer-edit","manager-create":"manager-create","manager-edit":"manager-edit","offer-create":"offer-create","offer-edit":"offer-edit","user-create":"user-create","user-edit":"user-edit","dashboard":"dashboard","orders":"orders","customers":"customers","managers":"managers","offers":"offers","users":"users"}[chunkId]||chunkId) + "." + {"chunk-3116ee50":"31d6cfe0","chunk-2cd2af4c":"3fedcae5","chunk-519266b8":"82dec56c","chunk-531460d6":"fdfb8d87","chunk-71c199a0":"7dd2e4de","chunk-2d238485":"31d6cfe0","special-discounts":"245a34b2","chunk-dddfc850":"217b5172","chunk-24f583fd":"e15cb2e7","chunk-2d21df6c":"31d6cfe0","chunk-442933af":"31d6cfe0","cruise-edit":"dde8d55a","cruises":"3b527520","discounts":"99814961","ships":"7eb396b8","chunk-79b30151":"fdfb8d87","chunk-2d2088b5":"31d6cfe0","chunk-72a69a57":"cc32cc2e","chunk-2d0c7cc6":"31d6cfe0","chunk-53ea0f5a":"31d6cfe0","chunk-8c845234":"4eddee73","chunk-042822bf":"d49d8575","chunk-37415666":"1d0bbe72","chunk-5d45888e":"1d0bbe72","chunk-745d6175":"ac3ccd65","chunk-9a03d3ae":"581e6b60","chunk-b02a382c":"1d0bbe72","chunk-375e64b9":"fdfb8d87","chunk-5cd4f878":"93b70ac9","chunk-726df261":"704b3fd1","chunk-2d0df469":"31d6cfe0","chunk-9ddedc26":"31d6cfe0","chunk-c329f076":"fdfb8d87","customer-create":"a367981d","customer-edit":"c230b983","manager-create":"a367981d","manager-edit":"fd961b05","offer-create":"93b70ac9","offer-edit":"93b70ac9","user-create":"93b70ac9","user-edit":"5ca5187c","chunk-00d40b96":"245a34b2","chunk-16eba1b2":"245a34b2","dashboard":"82deaa25","orders":"fd0e4812","chunk-487b9338":"245a34b2","chunk-51f2f11e":"245a34b2","chunk-6580c0fe":"245a34b2","chunk-7feb6954":"245a34b2","chunk-816b0afa":"245a34b2","chunk-a0da63a2":"245a34b2","chunk-ac25a1f4":"245a34b2","customers":"245a34b2","managers":"245a34b2","offers":"245a34b2","users":"245a34b2","chunk-8c9caf88":"fc3aa2e3"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
